import React, { useState, useEffect, useContext } from "react";
import "./index.css";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import {
  getConfiguracaoGleba,
  getGlebas,
  getSafras,
  getTipoSafra,
  getProdutor,
  getFazenda,
} from "../../../../Services/programation.service";
import { ConfiguracaoGlebaContext } from "../../../../contexts/ConfiguracaoGlebaContext";

const Panel = ({ onFormValueChange }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const { setConfiguracaoGleba, configuracaoGleba, programacaoAlterada } =
    useContext(ConfiguracaoGlebaContext);

  const getTipoSafrafetch = async () => {
    const { res } = await getTipoSafra();
    if (res?.data) {
      const { data } = res;
      return data
        .filter((tipoSafra) => !tipoSafra.excluido)
        .map((tipoSafra) => ({
          label: tipoSafra.nome,
          value: tipoSafra.id,
        }));
    }
    return [];
  };
  const getSafrasfetch = async () => {
    const { res } = await getSafras();
    if (res?.data) {
      const { data } = res;
      return data
        .filter((safra) => !safra.excluido)
        .map((safra) => ({
          label: safra.nome,
          value: safra.id,
        }));
    }
    return [];
  };
  const getGlebasfetch = async () => {
    const { res } = await getGlebas(configuracaoGleba.fazendaId);
    if (configuracaoGleba.fazendaId) {
      if (res?.data) {
        const { data } = res;

        return data
          .filter((glebas) => !glebas.excluido)
          .map((glebas) => ({
            label: glebas.nome,
            value: glebas.id,
            area: glebas.area,
          }));
      }
    }
    return [];
  };

  const getProdutorFetch = async () => {
    const { res } = await getProdutor();
    if (res?.data) {
      const { data } = res;
      return data
        .filter((produtor) => !produtor.excluido)
        .map((produtor) => ({
          label: produtor.nome,
          value: produtor.id,
        }));
    }
    return [];
  };

  const getFazendaFetch = async () => {
    if (configuracaoGleba.produtorId) {
      const { res } = await getFazenda(configuracaoGleba.produtorId);
      if (res?.data) {
        const { data } = res;
        return data
          .filter((fazenda) => !fazenda.excluido)
          .map((fazenda) => ({
            label: fazenda.nome,
            value: fazenda.id,
          }));
      }
    }

    return [];
  };

  const tiposSafraQuery = useQuery(["tiposSafraQuery"], getTipoSafrafetch, []);
  const safrasQuery = useQuery(["safrasQuery"], getSafrasfetch, []);

  const glebasQuery = useQuery(
    ["glebasQuery", configuracaoGleba.fazendaId],
    getGlebasfetch,
    []
  );

  const produtorQuery = useQuery(["produtorQuery"], getProdutorFetch, []);
  const fazendasQuery = useQuery(
    ["fazendasQuery", configuracaoGleba.produtorId],
    getFazendaFetch,
    []
  );

  const handleSelectChangeGleba = (name) => {
    return (option) => {
      if (
        programacaoAlterada &&
        !window.confirm(
          "Você alterou a programação e não salvou. Se sair agora, vai perder as alterações. Deseja continuar?"
        )
      ) {
        return;
      }
      setConfiguracaoGleba((prevState) => ({
        ...prevState,
        [name]: option.value,
        defaultValues: {
          area: option.area,
        },
      }));
    };
    // setConfiguracaoGleba;
    //  onFormValueChange(name);
  };

  // Selects CONTROLADOS: mostram sempre o que está no estado. Assim, se a
  // técnica cancelar o aviso de "não salvou", o select volta pro valor antigo
  // (antes ficava mostrando o novo mesmo sem ter trocado de verdade).
  const opcaoDe = (lista, valor) =>
    (lista || []).find((o) => o.value === valor) || null;

  // Menu do dropdown ACIMA da barra fixa de área (zIndex 5 > 2). Estilo inline
  // porque seletor de classe css-* não sobrevive ao build de produção.
  const menuAcima = { menu: (base) => ({ ...base, zIndex: 5 }) };

  return (
    <div className="panel-container">
      <div className="header-panel-home">
        <div className="select-component">
          <h4 style={{ color: "white" }}>Produtor</h4>
          <Select
            name="Selecione"
            value={opcaoDe(produtorQuery.data, configuracaoGleba.produtorId)}
            onChange={onFormValueChange("produtorId")}
            options={produtorQuery.data}
            styles={menuAcima}
          />
        </div>
        <div className="select-component">
          <h4 style={{ color: "white" }}>Fazenda</h4>
          <Select
            key={configuracaoGleba.produtorId || "fazenda-vazia"}
            name="Selecione"
            style={{ width: "180px !important" }}
            value={opcaoDe(fazendasQuery.data, configuracaoGleba.fazendaId)}
            onChange={onFormValueChange("fazendaId")}
            options={fazendasQuery.data}
            isDisabled={!configuracaoGleba.produtorId}
            styles={menuAcima}
          />
        </div>
      </div>
      <div className="select-primary">
        {!!configuracaoGleba.produtorId && !!configuracaoGleba.fazendaId && (
          <div style={{ display: "flex", width: "100%" }}>
            <div className="select-component">
              <h4>Talhão</h4>
              <Select
                key={configuracaoGleba.fazendaId || "gleba-vazia"}
                name="Selecione"
                label="Selecione"
                value={opcaoDe(glebasQuery.data, configuracaoGleba.glebaId)}
                onChange={handleSelectChangeGleba("glebaId")}
                options={glebasQuery.data}
                styles={menuAcima}
              />
            </div>
            <div className="select-component">
              <h4>Tipo safra</h4>
              <Select
                name="Selecione"
                label="Selecione"
                value={opcaoDe(tiposSafraQuery.data, configuracaoGleba.tipoSafraId)}
                onChange={onFormValueChange("tipoSafraId")}
                options={tiposSafraQuery.data}
                styles={menuAcima}
              />
            </div>
            <div className="select-component">
              {" "}
              <h4>Safra</h4>
              <Select
                name="Selecione"
                label="Selecione"
                value={opcaoDe(safrasQuery.data, configuracaoGleba.safraId)}
                onChange={onFormValueChange("safraId")}
                options={safrasQuery.data}
                styles={menuAcima}
              />
            </div>
          </div>
        )}
      </div>
      <div className="select-second"></div>
    </div>
  );
};

export default Panel;
